import React from 'react';

export const Gallery: React.FC = () => {
  return (
    <section id="gallery" className="w-full px-8 py-24 md:px-24 bg-white flex flex-col items-center">
      
      {/* Featured Artwork 1: DAMASCA */}
      <div className="w-full max-w-6xl mb-24 flex flex-col items-center group cursor-pointer">
        <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
           <img 
            src="https://i.postimg.cc/HkZQy84d/IMG-3574.jpg" 
            alt="DAMASCA"
            className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
          />
        </div>
        <div className="mt-8 text-center">
          <h3 className="font-serif text-4xl md:text-5xl italic text-text mb-4">DAMASCA</h3>
          <div className="flex flex-col items-center gap-2">
            <span className="font-sans text-xs tracking-[0.2em] text-text uppercase">Featured Work</span>
            <div className="w-8 h-[1px] bg-accent/50"></div>
            <div className="flex flex-col items-center gap-1 mt-1">
              <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
              <span className="font-sans text-[10px] tracking-widest text-accent uppercase">350 x 200 cm</span>
              <span className="font-sans text-sm tracking-widest text-text uppercase mt-2 flex items-center gap-3">
                $100,000 USD
                <span className="text-red-700 font-medium">SOLD</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Artwork 2: ETERNAL LOVE */}
      <div className="w-full max-w-6xl mb-24 flex flex-col items-center group cursor-pointer">
        <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
           <img 
            src="https://i.postimg.cc/0yjh1mVC/IMG-3934.jpg" 
            alt="Eternal Love"
            className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
          />
        </div>
        <div className="mt-8 text-center">
          <h3 className="font-serif text-4xl md:text-5xl italic text-text mb-4">Eternal Love</h3>
          <div className="flex flex-col items-center gap-2">
            <div className="w-8 h-[1px] bg-accent/50"></div>
            <div className="flex flex-col items-center gap-1 mt-1">
              <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
              <span className="font-sans text-[10px] tracking-widest text-accent uppercase">250 x 150 cm</span>
              <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$25,000 USD</span>
            </div>
          </div>
        </div>
      </div>

      {/* THE KNIGHTS Series: "1", "2", "3" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-12">
         {/* KNIGHTS 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/rsXfcmZj/6eb30fd0-d22f-11f0-846a-fd2ec1256e38.jpg" 
                alt="THE KNIGHTS 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">THE KNIGHTS "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">250 x 150 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$25,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* KNIGHTS 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/MH5V4KCH/945d1730-d22f-11f0-846a-fd2ec1256e38.jpg" 
                alt="THE KNIGHTS 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">THE KNIGHTS "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">250 x 150 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$25,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* KNIGHTS 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/9FXG9Z9K/8c95f8a0-d22f-11f0-846a-fd2ec1256e38.jpg" 
                alt="THE KNIGHTS 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">THE KNIGHTS "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">250 x 150 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$25,000 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* Side by Side Featured: MATADOR "1" & MATADOR "2" */}
      <div className="w-full max-w-6xl mb-12 md:mb-24 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
         {/* MATADOR 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/q7LKchd5/4.jpg" 
                alt="MATADOR 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">MATADOR "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* MATADOR 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/8C06n8jf/3.jpg" 
                alt="MATADOR 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">MATADOR "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* Side by Side Featured: MATADOR "3" & MATADOR "4" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
         {/* MATADOR 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/QtgjK1G3/5.jpg" 
                alt="MATADOR 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">MATADOR "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* MATADOR 4 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/TYDCV9N7/8.jpg" 
                alt="MATADOR 4"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">MATADOR "4"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* NEW UNTITLED Series (Under Matadors): "1", "2", "3", "4" - $10,000 */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
         {/* UNTITLED 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/XYCcN3dW/a4c4b270-d231-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/PrzvSxWT/9220a9d0-d231-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/KY4KcDdQ/9ea2df70-d231-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 4 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/PxwPYrX0/8cbea460-d231-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 4"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "4"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$10,000 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* CLOWN Series: CLOWN "1", "2", "3" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-12">
         {/* CLOWN 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/8cDMLRFG/1.jpg" 
                alt="CLOWN 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">CLOWN "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">90 x 60 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* CLOWN 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/fRFd8n35/6.jpg" 
                alt="CLOWN 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">CLOWN "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">90 x 60 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* CLOWN 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/505F9XsR/7.jpg" 
                alt="CLOWN 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">CLOWN "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">90 x 60 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* Side by Side Featured: BALLERINA "1" & BALLERINA "2" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
         {/* BALLERINA 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/cCtMS4wV/222833d0-d134-11f0-aa50-4795383fdee1.jpg" 
                alt="BALLERINA 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">BALLERINA "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* BALLERINA 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/BQWwndbP/2a9de1e0-d134-11f0-aa50-4795383fdee1.jpg" 
                alt="BALLERINA 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">BALLERINA "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* REBORN FACES Series: "1", "2", "3" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-12">
         {/* REBORN FACES 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/438zHh5k/1487d970-d133-11f0-9e75-d9e63b3e9f05.jpg" 
                alt="REBORN FACES 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">REBORN FACES "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* REBORN FACES 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/wTH7HjXQ/df152400-d132-11f0-aed1-cdaa00670961.jpg" 
                alt="REBORN FACES 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">REBORN FACES "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* REBORN FACES 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/x8PjqLvM/09049d40-d133-11f0-9e75-d9e63b3e9f05.jpg" 
                alt="REBORN FACES 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              />
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">REBORN FACES "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$7,500 USD</span>
                </div>
              </div>
            </div>
         </div>
      </div>

      {/* UNTITLED Series: "1", "2", "3", "4" */}
      <div className="w-full max-w-6xl mb-32 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
         {/* UNTITLED 1 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/NG20zMwn/d928fa90-d230-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 1"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              /> 
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "1"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$5,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 2 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/FzTGSZHN/e3dfe610-d230-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 2"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              /> 
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "2"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$5,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 3 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/9FNJFJk7/d4352040-d230-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 3"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              /> 
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "3"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$5,000 USD</span>
                </div>
              </div>
            </div>
         </div>

         {/* UNTITLED 4 */}
         <div className="flex flex-col items-center group cursor-pointer">
            <div className="relative w-full shadow-sm overflow-hidden bg-stone-100">
               <img 
                src="https://i.postimg.cc/Pq14yh56/df5750b0-d230-11f0-846a-fd2ec1256e38.jpg" 
                alt="UNTITLED 4"
                className="w-full h-auto object-cover grayscale-[10%] group-hover:grayscale-0 transition-all duration-1000 ease-out"
              /> 
            </div>
            <div className="mt-8 text-center">
              <h3 className="font-serif text-3xl italic text-text mb-4">UNTITLED "4"</h3>
              <div className="flex flex-col items-center gap-2">
                <div className="w-8 h-[1px] bg-accent/50"></div>
                <div className="flex flex-col items-center gap-1 mt-1">
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">Oil on Canvas, 2024</span>
                  <span className="font-sans text-[10px] tracking-widest text-accent uppercase">120 x 80 cm</span>
                  <span className="font-sans text-sm tracking-widest text-text uppercase mt-2">$5,000 USD</span>
                </div>
              </div>
            </div>
         </div>

      </div>
    </section>
  );
};